import { memo, useRef } from "react";

import LOCAL_STORAGE from "@utils/localStorage";
import FavActiveSvg from "@assets/icons/FavActiveSvg";

import "./Cards.scss";

export default memo(function CardChannel({
  image,
  id,
  isActive,
  className = "",
  index,
  onClick,
  style,
  isFavorite,
  elem,
}) {
  const clickTimeoutRef = useRef(null);

  const handleClick = () => {
    // Prevent rapid clicks by using a flag
    if (clickTimeoutRef.current) return;

    if (onClick && typeof id !== "undefined" && typeof index !== "undefined") {
      clickTimeoutRef.current = true;
      console.log(`Card clicked: ${id}, index: ${index}`);
      onClick(id, index);

      // Reset the click flag after a delay
      setTimeout(() => {
        clickTimeoutRef.current = null;
      }, 300);
    }
  };

  const handleImageError = (e) => {
    const fallbackLogo = LOCAL_STORAGE.LOGO.GET();
    if (fallbackLogo) {
      e.target.src = fallbackLogo;
    }
  };

  return (
    <div className="main-card_wrapper" style={style}>
      <div
        className={`main-card-channel ${className}${isActive ? " active" : ""}`}
        onClick={handleClick}
      >
        <img src={image} onError={handleImageError} alt="Channel logo" />
        {isFavorite && (
          <div className="favorite-icon">
            <FavActiveSvg isActive={true} />
          </div>
        )}
      </div>
    </div>
  );
});
